<template>
  <div class="app-body_show container-fluid pb-5 search">
    <static-messages v-if="error"
      :messages="error"
      :variant="`danger`"
      :class="`mt-4`"
      @closed="error = null">
    </static-messages>

    <router-view v-if="isLoaded && isBookmarkFoldersLoaded"
      :isLoaded="isLoaded"
      :user="user"
      :researcher="researcher"
      :isBookmarkFoldersLoaded="isBookmarkFoldersLoaded">
    </router-view>

    <!-- lists not loaded -->
    <div v-else class="card mt-4">
      <div class="card-body">
        <spinner :containerClass="`width--50px min-height--150px`" />
      </div>
    </div>
  </div>
</template>

<script>
import StaticMessages from '@/components/shared/StaticMessages'
import Spinner from '@/components/shared/Spinner'

// import UserService from '@/services/user'
import { mapActions } from 'vuex'

export default {
  name: 'userBookmarkFoldersBase',
  components: {
    StaticMessages,
    Spinner
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    searchFilterObject: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      error: null,
      isBookmarkFoldersLoaded: false
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.list !== from.params.list) this.fetch(this.user.id)
    next()
  },
  mounted () {
    if (this.isLoaded && !this.isEmpty(this.user.id)) this.fetch(this.user.id)
  },
  watch: {
    isLoaded (newVal, oldVal) {
      if (newVal !== oldVal && newVal) this.fetch(this.user.id)
    }
  },
  methods: {
    ...mapActions('bookmarks', [
      'getBookmarkFolders'
    ]),
    fetch (userId) {
      if (this.isEmpty(userId)) {
        this.$router.replace({ name: 'researcher.show', params: { id: this.researcher.slug_values[0] } })
      } else {
        this.isBookmarkFoldersLoaded = false

        this.getBookmarkFolders({ userId, useCache: false }).then(() => {
          this.isBookmarkFoldersLoaded = true
        }, err => {
          this.error = this.handleError(err)
          this.isBookmarkFoldersLoaded = !this.isEmpty(this.error)
        })
      }
    }
  }
}
</script>
